export default __webpack_public_path__ + "static/media/vijhe.e6e50718.jpg";